/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const UNDO_VIEWBOX = 16;

const UNDO_ARC_PATH =
  'M2 8C2 11.3115 4.68851 14 8 14C11.3115 14 14 11.3115 14 8C14 4.68851 11.3115 2 8 2C6.32263 2.00631 4.71265 2.66082 3.50667 3.82667L2 5.33333';

const UNDO_ARROW_PATH = 'M2 2V5.33333H5.33333';

const iconPropTypes = {
  size: PropTypes.number,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Undo / retry (16×16). Counter-clockwise circular arrow.
 * Color via `stroke` / `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const UndoIcon = ({
  size = 16,
  stroke = 'currentColor',
  strokeWidth = 1.33333,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${UNDO_VIEWBOX} ${UNDO_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d={UNDO_ARC_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d={UNDO_ARROW_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

UndoIcon.propTypes = iconPropTypes;

export { UndoIcon };
export default UndoIcon;